import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { EQUIPMENT_SERVICES, SUPPORT_SERVICES } from '../data/services';
import { COMPANY } from '../data/company';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='45' fill='%23ea580c' stroke='%23fff' stroke-width='2'/%3E%3Cpath d='M20 35h15v6H20zm0 10h25v6H20zm45 15c0 5-4 9-9 9s-9-4-9-9 4-9 9-9 9 4 9 9zm-25 0c0 5-4 9-9 9s-9-4-9-9 4-9 9-9 9 4 9 9z' fill='%23fff'/%3E%3Cpath d='M25 45h35l5 10H25z' fill='%23fff'/%3E%3C/svg%3E"
                alt="Flow Fleet Solutions Logo"
                className="h-8 w-8"
              />
              <h3 className="text-xl font-bold text-white">Flow Fleet Solutions</h3>
            </div>
            <p className="text-gray-300 mb-4 text-sm">
              Professional truck dispatch services helping owner operators and fleets maximize revenue
              through premium loads, broker negotiation, and dedicated dispatch support.
            </p>
            <div className="flex items-start gap-2 text-orange-400 text-sm">
              <MapPin className="h-5 w-5 flex-shrink-0" />
              <span>Florida • Southeast US • Nationwide Dispatch</span>
            </div>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Dispatch by Equipment</h4>
            <ul className="space-y-2 text-gray-300 text-sm">
              {EQUIPMENT_SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} className="hover:text-orange-400 transition-colors" data-testid={`footer-service-${s.slug}`}>
                    {s.shortName}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Support & Compliance</h4>
            <ul className="space-y-2 text-gray-300 text-sm">
              {SUPPORT_SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} className="hover:text-orange-400 transition-colors" data-testid={`footer-service-${s.slug}`}>
                    {s.shortName}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3 text-sm">
              <a href={COMPANY.phoneHref} className="flex items-center gap-3 text-gray-300 hover:text-orange-400" data-testid="footer-phone">
                <Phone className="h-5 w-5 text-orange-400" />
                <span>{COMPANY.phoneDisplay}</span>
              </a>
              <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 text-gray-300 hover:text-orange-400 break-all" data-testid="footer-email">
                <Mail className="h-5 w-5 text-orange-400 flex-shrink-0" />
                <span>{COMPANY.email}</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mb-6 text-sm">
            <Link to="/blog" className="text-gray-300 hover:text-orange-400" data-testid="footer-blog">Blog</Link>
            <Link to="/tools" className="text-gray-300 hover:text-orange-400" data-testid="footer-tools">Calculators</Link>
            <Link to="/resources" className="text-gray-300 hover:text-orange-400" data-testid="footer-resources">Resource Center</Link>
            <span className="text-gray-700">|</span>
            <Link to="/locations/miami-dispatch-services" className="text-gray-300 hover:text-orange-400" data-testid="footer-location-miami">Miami</Link>
            <Link to="/locations/broward-county-dispatch" className="text-gray-300 hover:text-orange-400" data-testid="footer-location-broward">Broward County</Link>
            <Link to="/locations/palm-beach-dispatch" className="text-gray-300 hover:text-orange-400" data-testid="footer-location-palm-beach">Palm Beach</Link>
            <Link to="/locations/florida-freight-dispatch" className="text-gray-300 hover:text-orange-400" data-testid="footer-location-florida">Florida Freight</Link>
            <Link to="/locations/southeast-regional-dispatch" className="text-gray-300 hover:text-orange-400" data-testid="footer-location-southeast">Southeast Regional</Link>
            <span className="text-gray-700">|</span>
            <Link to="/privacy" className="text-gray-300 hover:text-orange-400" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-300 hover:text-orange-400" data-testid="footer-terms">Terms of Service</Link>
            <Link to="/cookies" className="text-gray-300 hover:text-orange-400" data-testid="footer-cookies">Cookie Policy</Link>
          </div>
          <p className="text-gray-400 text-sm text-center">
            © {new Date().getFullYear()} Flow Fleet Solutions. All rights reserved. | Truck Dispatch Services
          </p>
        </div>
      </div>
    </footer>
  );
};
